import ACTIONS from "../actions/types";

const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  isFetching: false,
  loginFailed: false,
  errorMessage: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.FETCH_LOGIN:
      return Object.assign({}, state, {
        isFetching: true,
      });
    // make a new object of state, where you changes
    // isFetching to true
    case ACTIONS.FETCH_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload.user,
        token: action.payload.token,
        isLoggedIn: true,
        isFetching: false,
        loginFailed: false,
        errorMessage: null,
      });
    case ACTIONS.FETCH_LOGIN_FAILURE:
      return Object.assign({}, state, {
        user: null,
        token: null,
        isLoggedIn: false,
        isFetching: false,
        loginFailed: true,
        errorMessage: action.payload.error ? action.payload.error : action.payload,
      });
    case ACTIONS.REHYDRATE_AUTH_USER:
      return Object.assign({}, state, {
        user: action.payload.user,
        token: action.payload.token,
        isLoggedIn: true,
        isFetching: false,
        loginFailed: false,
        errorMessage: null,
      });
    case ACTIONS.CLEAR_ERROR_TOAST:
      return Object.assign({}, state, {
        loginFailed: false,
        errorMessage: null,
      });
    case ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
